<template>
  <div class="backgroudColor">
    <el-row class="content">
      <el-col :span="16">
        <el-row>
          <el-col :span="24">
            <ResumeTitle />
          </el-col>
        </el-row>
        <el-row class="persionMsg">
          <el-col :offset="1" :span="24" class>
            <el-form
              ref="form"
              :rules="rules"
              label-position="top"
              :model="form"
            >
              <el-row>
                <el-col :span="15">
                  <el-form-item
                    label="姓名"
                    class="fromLabelFont"
                    prop="ucUsername"
                    style="margin-top: 20px"
                  >
                    <el-input
                      v-model="form.ucUsername"
                      class="oneInputWidthShot"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="7" style="margin: 20px 0 0; float: right">
                  <el-upload
                    ref="uploadAvatar"
                    class="avatar-uploader"
                    :action="getUploadAction('avatar')"
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                    accept=".jpg, .jpeg, .png, .JPG, .JPEG, .PBG"
                  >
                    <img
                      v-if="form.ucHeadPic"
                      :src="form.ucHeadPic"
                      class="avatar"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-col>
              </el-row>

              <el-dialog
                title="图片剪裁"
                style="width: 100vh; margin: 0 auto"
                :visible.sync="dialogVisible"
              >
                <div class="wrapper" style="width: 55vh">
                  <div class="model" v-show="model">
                    <div class="model-show" @click="model = false">
                      <!-- <img :src="modelSrc" alt @click="model = false" /> -->
                    </div>
                  </div>
                  <div class="content">
                    <div class="show-info">
                      <div class="test test1">
                        <vueCropper
                          ref="cropper"
                          :img="option.img"
                          :outputSize="option.size"
                          :outputType="option.outputType"
                          :info="true"
                          :full="option.full"
                          :canMove="option.canMove"
                          :canMoveBox="option.canMoveBox"
                          :fixedBox="option.fixedBox"
                          :original="option.original"
                          :autoCrop="option.autoCrop"
                          :autoCropWidth="option.autoCropWidth"
                          :autoCropHeight="option.autoCropHeight"
                          :centerBox="option.centerBox"
                          :high="option.high"
                          :infoTrue="option.infoTrue"
                          :maxImgSize="option.maxImgSize"
                          @imgLoad="imgLoad"
                          @cropMoving="cropMoving"
                          :enlarge="option.enlarge"
                          :mode="option.mode"
                          :limitMinSize="option.limitMinSize"
                          style="width: 46vh;height:450px"
                        ></vueCropper>
                      </div>
                    </div>
                  </div>
                </div>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="dialogVisible = false">取 消</el-button>
                  <el-button
                    type="primary"
                    :loading="loading"
                    @click.native="finish('blob')"
                    >确认</el-button
                  >
                  <!-- @click="finish" -->
                </div>
              </el-dialog>

              <el-row>
                <el-col :span="24" style="margin-top: -20px">
                  <el-form-item label="性别" class="fromLabelFont" prop="ucSex">
                    <el-radio-group v-model="form.ucSex" size="medium">
                      <el-radio
                        v-for="item in selectSex"
                        :key="item.value"
                        :label="item.value"
                        style="width: 260px"
                        @change="changeUserDefaultIcon"
                        border
                        >{{ item.text }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <el-form-item
                    label="我的公司"
                    class="fromLabelFont"
                    prop="ucComName"
                  >
                    <!-- <el-input v-model="form.ucComName" class="oneInputWidth"></el-input> -->

                    <el-autocomplete
                      class="inline-input"
                      v-model="form.ucComName"
                      :fetch-suggestions="querySearch"
                      placeholder="请输入内容"
                      :trigger-on-focus="false"
                      @select="handleSelect"
                      style="width: 540px"
                    ></el-autocomplete>
                  </el-form-item>
                </el-col>

                <el-col class="regeditDesc" :span="24" style="margin-top: -5px"
                  >注意事项:</el-col
                >
                <el-col class="regeditDesc" :span="24" style
                  >1.请输入您所属公司营业执照上的公司名称</el-col
                >
                <el-col class="regeditDesc" :span="24" style
                  >2.请注意区分总公司和分公司</el-col
                >
                <el-col class="regeditDesc" :span="24" style
                  >3.公司名称将用于后续的企业认证使用，请确保准确性</el-col
                >
              </el-row>

              <el-row>
                <el-col :span="24">
                  <el-form-item
                    label="公司简称"
                    class="fromLabelFont"
                    prop="comAbbreviation"
                  >
                    <!-- <el-input v-model="form.ucComName" class="oneInputWidth"></el-input> -->
                    <el-input
                      v-model="form.comAbbreviation"
                      class="oneInputWidth"
                      maxlength="6"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24" style="margin-top: 20px">
                  <el-form-item label="上传营业执照" class="fromLabelFont">
                    <el-upload
                      class="avatar-uploader-company"
                      :action="getUploadAction('avatar')"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess"
                      style
                    >
                      <img
                        v-if="comBusinessLicense"
                        :src="comBusinessLicense"
                        class="avatar"
                      />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col class="regeditDesc" :span="24" style="margin-top: -20px"
                  >证照完整、清晰、有效；</el-col
                >
                <el-col class="regeditDesc" :span="24" style
                  >营业执照有效期必须大于15天；</el-col
                >
                <el-col class="regeditDesc" :span="24" style
                  >证照不能为电子版或截屏；</el-col
                >
                <el-col class="regeditDesc" :span="24" style
                  >营业执照政府章与工商局登记机关信息一致。</el-col
                >
              </el-row>

              <el-row style="margin-top: 20px">
                <el-col :span="24">
                  <el-form-item
                    label="我的职位"
                    prop="ucPosition"
                    class="fromLabelFont"
                  >
                    <el-input
                      v-model="form.ucPosition"
                      class="oneInputWidth"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <el-form-item
                    label="公司所在行业"
                    prop="ucIndustry"
                    class="fromLabelFont"
                  >
                    <!-- <el-input v-model="form.ucIndustry" class="oneInputWidth"></el-input> -->
                    <el-select v-model="form.ucIndustry" class="inputWidth">
                      <el-option
                        v-for="(item, index) in selectIndustry"
                        :key="index"
                        :label="item.cate.name"
                        :value="item.cate.code"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <el-form-item
                    label="座机电话"
                    prop="ucLandline"
                    class="fromLabelFont"
                  >
                    <el-input
                      v-model="form.ucLandline"
                      class="oneInputWidth"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <el-form-item
                    label="邮箱"
                    prop="ucEmail"
                    class="fromLabelFont"
                  >
                    <el-input
                      v-model="form.ucEmail"
                      class="oneInputWidth"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <!-- <router-link v-bind:to="'/usersResumeCompany/'" class="fontStyle footFont"> -->
                  <el-button
                    plain
                    class="loginButton"
                    @click.native="goResumeCompany('form')"
                    >保存 去发布一个职位</el-button
                  >
                  <!-- </router-link> -->
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ResumeTitle from "@/components/ResumeTitle.vue";
import { mapGetters, mapActions } from "vuex";
import { initDictOptions, filterDictText } from "@/comm/JDictSelectUtil";
import { getAction, postAction } from "@/comm/manage";
import {
  validateIdNo,
  validatePhone,
  validateEMail,
  validateTelphone,
} from "@/utils/validate";
import { VueCropper } from "vue-cropper";
import codes from "@/components/code";
import { addIMUser } from "@/comm/api";
export default {
  name: "UsersResume",
  components: {
    ResumeTitle,
    VueCropper,
  },
  props: {
    msg: String,
  },

  data() {
    return {
      loginPhone: "",
      selectSex: "",
      selectIndustry: null,
      dialogVisible: false,
      loading: false,
      model: false,
      modelSrc: "",
      crap: false,
      comBusinessLicense: null,
      previews: {},
      option: {
        img: "",
        size: 1,
        full: false,
        outputType: "png",
        canMove: true,
        fixedBox: false,
        original: false,
        canMoveBox: true,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 200,
        autoCropHeight: 150,
        centerBox: false,
        high: false,
        cropData: {},
        enlarge: 1,
        mode: "contain",
        maxImgSize: 3000,
        limitMinSize: [100, 120],
      },
      form: {
        ucId: null,
        ucUsername: null,
        ucComName: null,
        ucPosition: null,
        ucSex: null,
        ucPhone: null,
        ucLandline: null,
        ucHeadPic: null,
        ucIndustry: null,
        ucType: "0",
        companyData: "",
        comBusinessLicense: null,
        comAbbreviation: null,
      },
      rules: {
        ucUsername: [
          { required: true, message: "请输入您的名称", trigger: "change" },
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        ucComName: [
          { required: true, message: "请输入公司名称", trigger: "change" },
        ],
        ucPosition: [
          { required: true, message: "请输入您职位", trigger: "change" },
        ],

        ucSex: [
          { required: true, message: "请选择您的性别", trigger: "change" },
        ],

        ucIndustry: [
          { required: true, message: "请选择公司所在的行业", trigger: "click" },
        ],
        ucLandline: [
          { required: true, message: "请输入座机号码", trigger: "blur" },
          { validator: validateTelphone, trigger: "blur" },
        ],

        ucEmail: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: validateEMail, trigger: "blur" },
        ],
        comAbbreviation: [
          { required: true, message: "请输入公司简称", trigger: "change" },
        ],
      },
      status: [{ validator: "checkStatus", trigger: "change" }],
    };
  },
  created: function () {
    
    this.form = this.$route.params.userInfo;

    // this.$store.dispatch("setIsShowHead", false);

    this.initDictConfig();
    
    if (!this.form || !this.form.ucPhone) {
      this.$router.push("/pcRegedit");
    }
    this.loadCategories();
  },
  mounted() {
    this.findAllCompany();
  },
  methods: {
    findAllCompany() {
      initDictOptions("company_code").then((res) => {
        if (res.success) {
          this.restaurants = res.result;
        }
      });
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) !=
          -1
        );
      };
    },

    handleSelect(item) {
      this.selectCompany = JSON.stringify([item]);
      console.log(item);
    },
    initDictConfig() {
      //初始化字典 - 性别
      initDictOptions("sex").then((res) => {
        if (res.success) {
          this.selectSex = res.result;
        }
      });
    },
    getUploadAction: function (value) {
      return window._CONFIG["domianURL"] + "/cos/file/upload";
    },

    loadCategories() {
      let params = { pid: 0 };
      getAction("/sys/category/allList", params).then((res) => {
        if (res.success) {
          this.selectIndustry = res.result;
        } else {
          this.$message.warning(res.message);
        }
      });
    },

    goResumeCompany: function (formName) {
      
      if (!this.form.comBusinessLicense) {
        this.$message.error("营业执照必须上传");
        return false;
      }
      let companyInfo = {};
      companyInfo.comBusinessLicense = this.form.comBusinessLicense;
      companyInfo.comLandline = this.form.ucLandline;
      companyInfo.comIndustry = this.form.ucIndustry;
      companyInfo.comAbbreviation = this.form.comAbbreviation;

      this.form.companyData = JSON.stringify(companyInfo);

      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          postAction("/userRegedit/logReg/addCompanyUser", that.form).then(
            (res) => {
              if (res.success) {
                try {
                  addIMUser({
                    Identifier: res.result.ucId,
                    Nick: that.form.ucUsername,
                    FaceUrl: that.form.ucHeadPic,
                  });
                  that.$message.success("用户成功注册");
                  this.$refs["form"].resetFields();
                  that.$router.push("/");
                } catch {
                  that.$router.push("/");
                }
              } else {
                console.log(res);
              }
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    finish(type) {
      // 输出
      let _this = this;
      let formData = new FormData();
      if (type === "blob") {
        this.$refs.cropper.getCropBlob((data) => {
          var img = window.URL.createObjectURL(data);

          formData.append("file", data, "avatar.png");
          postAction(this.getUploadAction("avatar"), formData, {
            contentType: false,
            processData: false,
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }).then((response) => {
            var res = response;
            if (res.success == 1) {
              _this.$message({
                //element-ui的消息Message消息提示组件
                type: "success",
                message: "上传成功",
              });
              const uploadFilePath =res.message;
              _this.form.ucHeadPic = uploadFilePath;
              _this.dialogVisible = false;
            }
          });
        });
      } else {
        this.$refs.cropper.getCropData((data) => {
          this.model = true;
          this.modelSrc = data;
        });
      }
    },
    uploadImg(e, num) {
      //上传图片
      // this.option.img
      // var file = e.target.files[0];
      var file = e;
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.name)) {
        alert("图片类型必须是.gif,jpeg,jpg,png,bmp中的一种");
        return false;
      }
      var reader = new FileReader();
      reader.onload = (e) => {
        let data;
        if (typeof e.target.result === "object") {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        if (num === 1) {
          this.option.img = data;
        }
        // this.$refs.uploadImg.value = "";
      };
      // 转化为base64
      // reader.readAsDataURL(file)
      // 转化为blob
      reader.readAsArrayBuffer(file);
    },
    onSubmit: function () {},
    handleAvatarSuccess(res, file) {
      // this.comBusinessLicense =
      //   window._CONFIG["domianURL"] + "/sys/common/view/" + res.message;
      
      this.form.comBusinessLicense = res.message;
      this.comBusinessLicense = res.message;
      // this.form.u = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      this.dialogVisible = true;

      this.uploadImg(file, 1);

      return false;
    },
    changeUserDefaultIcon() {
      

      if (
        !this.form.ucHeadPic ||
        this.form.ucHeadPic.indexOf("/default") != -1
      ) {
        if (this.form.ucSex == 1) {
          this.form.ucHeadPic =
            window._CONFIG["domianURL"] +
            "/sys/common/view/" +
            "files/20200922/defaultManIcon2x.png";
        } else {
          this.form.ucHeadPic =
            window._CONFIG["domianURL"] +
            "/sys/common/view/" +
            "files/20200922/defaultGrilIcon2x.png";
        }
      }
    },
    imgLoad(msg) {
      console.log(msg);
    },

    cropMoving(data) {
      this.option.cropData = data;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.persionMsg {
  background: rgba(255, 255, 255, 1);
  height: 110%;
  width: 860px;
}

.loginButton {
  width: 380px;
  height: 50px;
  background: #f82b18;
  color: rgba(255, 255, 255, 1);
  // margin-left: 25%;
  margin: 50px 0 50px 25%;
}

.persionMsg div {
  margin-right: 22px;
  text-align: left;

  .fromLabelFont >>>.el-form-item__label {
    font-size: 16px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 24px;
  }
}

.regeditDesc {
  color: #C0C4CC;
}

.oneInputWidth {
  width: 68.8%;
  height: 40px;
}

.oneInputWidthShot {
  width: 180px;
  height: 40px;
}

.content {
  text-align: right;
  width: 860px;
  margin: 0 auto;
}

.backgroudColor {
  background-color: rgba(246, 246, 248, 1);
  width: 100%;
  height: 100%;
}

.avatar-uploader >>>.el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 60px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-company >>>.el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
</style>

<style lang="stylus" scoped>
>>>.el-dialog__body {
  padding: 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  height: 50vh;
}

.wrapper {
  * {
    margin: 0;
    padding: 0;
  }

  .content {
    margin: auto;
    max-width: 1200px;
    margin-bottom: 100px;
  }

  .test-button {
    display: flex;
    flex-wrap: wrap;
  }

  .btn {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #c0ccda;
    color: #1f2d3d;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 20px 10px 0px 0px;
    padding: 9px 15px;
    font-size: 14px;
    border-radius: 4px;
    color: #fff;
    background-color: #50bfff;
    border-color: #50bfff;
    transition: all 0.2s ease;
    text-decoration: none;
    user-select: none;
  }

  .show-info {
    margin-bottom: 50px;
  }

  .show-info h2 {
    line-height: 50px;
  }

  .test {
    height: 500px;
  }

  .model {
    position: fixed;
    z-index: 10;
    width: 100vw;
    height: 100vh;
    overflow: auto;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
  }

  .model-show {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    text-align: center;
  }

  .model img {
    display: block;
    margin: auto;
    max-width: 80%;
    width: auto;
    user-select: none;
    background-position: 0px 0px, 10px 10px;
    background-size: 20px 20px;
    background-image: linear-gradient(
      45deg,
      #eee 25%,
      transparent 25%,
      transparent 75%,
      #eee 75%,
      #eee 100%
    ), linear-gradient(45deg, #eee 25%, white 25%, white 75%, #eee 75%, #eee 100%);
  }

  .pre {
    display: flex;
    flex-wrap: wrap;
  }

  @keyframes slide {
    0% {
      background-position: 0 0;
    }

    100% {
      background-position: -100% 0;
    }
  }

  @media screen and (max-width: 1000px) {
    .content {
      max-width: 90%;
      margin: auto;
    }

    .test {
      height: 400px;
    }
  }
}
</style>